// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import dayjs from 'dayjs'
import { get } from 'lodash'
import Flatpickr from 'react-flatpickr'
import { FormFieldLayout } from '../../generic'

export default function TimeField({
  errors,
  formKey,
  onChange,
  style,
  values,
  ...props
}) {
  const error = get(errors, formKey)

  const handleTimeChange = (newDate) => {
    onChange({
      key: formKey,
      value: dayjs(newDate[0]).format('HH:mm')
    })
  }

  const timeOptions = {
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i',
    time_24hr: true
  }

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <div className={css(classes.timeInputContainer)}>
        <Flatpickr
          className={css(classes.input, classes.timeInput)}
          placeholder="HH:MM"
          options={timeOptions}
          onChange={handleTimeChange}
        />
      </div>
    </FormFieldLayout>
  )
}

const classes = StyleSheet.create({
  timeInputContainer: {
    display: 'flex'
  },
  input: {
    textAlign: 'center',
    border: `1px solid ${colors.grey}`,
    borderRadius: 4,
    width: 100,
    letterSpacing: 1,
    padding: '9.5px 4px',
    '::placeholder': {
      fontStyle: 'italic',
      color: colors.darkgrey
    }
  },
  dateInput: {
    marginRight: 15
  }
})
